import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AutoCompleteKeyword, AutoCompleteKeywordCreate } from "@/model";
import autoCompleteKeywordRepository from "@/repository/autoCompleteKeywordRepository";


export const useCreateAutocompleteKeyword = (agentId: number, autocompleteId: string) => {
    const queryClient = useQueryClient();

    return useMutation<AutoCompleteKeyword, AxiosError, AutoCompleteKeywordCreate>({
        mutationKey: [agentId, autocompleteId, 'autocomplete-keyword', 'create'],
        mutationFn: async (body: AutoCompleteKeywordCreate) => {
            try {
                const { data } = await autoCompleteKeywordRepository.create(agentId,autocompleteId, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["autocomplete-keyword"]
        });
        }
    });
};
